import script from "./VenueDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueDetail.vue?vue&type=script&setup=true&lang=js"

import "./VenueDetail.vue?vue&type=style&index=0&id=5167806e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5167806e"]])

export default __exports__